import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { useAuth } from "@clerk/react";
import { ApiClient, UnauthorizedError } from "../lib/api";
import { useEntityLabels } from "./useEntityLabels";

export function useGetTeams() {
	const { getToken, signOut } = useAuth();
	const client = new ApiClient(getToken);

	const { set: setLabel } = useEntityLabels();

	const query = useQuery({
		queryKey: ["getTeams"],
		queryFn: async () => {
			const response = await client.getTeams();

			for (const team of response.teams) {
				console.log(team);

				if (team.mlbStatsData?.name || team.apiSportsData?.name) {
					setLabel(
						`team:${team.normalizedName}`,
						team.mlbStatsData?.name || team.apiSportsData?.name || "",
					);
				}
			}

			return response;
		},
		retry: (failureCount, error) => {
			if (error instanceof UnauthorizedError) return false;
			return failureCount < 3;
		},
	});

	useEffect(() => {
		if (query.error instanceof UnauthorizedError) {
			void signOut();
		}
	}, [query.error, signOut]);

	return query;
}
